export default {
  isIdeaOffer : true,
  type : ''
};



// WEBPACK FOOTER //
// ./src/store/modules/sidebar/state.js